export class ClickDTO {
  constructor(type, data, component = null, metadata = {}) {
    this.type = type;           // ClickableType enum
    this.data = data;           // The actual data
    this.component = component; // React component ref (optional)
    this.metadata = metadata;   // Extra info (position, team, etc)
    this.timestamp = Date.now();
    this.id = `${type}_${data?.id || 'none'}_${this.timestamp}`;
  }

  isSameTarget(other) {
    if (!other) return false;
    return this.type === other.type &&
           this.data?.id === other.data?.id;
  }
}